import React from 'react';
import MediaDisplay from '@/components/media/MediaDisplay';

export default function ProjectCoverMedia({ project, className = '' }) {
  const type = project.cover_media_type || 'image';
  const url = type === 'video' ? project.cover_video_url : project.cover_image;
  return <MediaDisplay type={type} url={url} meta={project.cover_image_meta || { title: project.title }} autoplay={type === 'video'} className={className} />;
}